import View from 'client/components/common/BuildingBlocks/Card/Card';
import model from 'client/components/common/BuildingBlocks/Card/model';

export const CARD = () => ({
	view: View,
	get model() {
		return model();
	},
});
